package com.devi3east.bashbuddy.purchase.domain.models

import com.devi3east.bashbuddy.account.profile.domain.models.Profile
import kotlinx.serialization.Serializable

@Serializable
data class Allocation(
    val profile: Profile,
    val ticketTitle: String,
    val allocationId: String,
    val chanceNumbers: List<String> = emptyList()
)